/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiModelsEnumerationTypesDisplayType } from './WebApiModelsEnumerationTypesDisplayType';
import {
    WebApiModelsEnumerationTypesDisplayTypeFromJSON,
    WebApiModelsEnumerationTypesDisplayTypeFromJSONTyped,
    WebApiModelsEnumerationTypesDisplayTypeToJSON,
} from './WebApiModelsEnumerationTypesDisplayType';
import type { WebApiModelsEnumerationTypesEventType } from './WebApiModelsEnumerationTypesEventType';
import {
    WebApiModelsEnumerationTypesEventTypeFromJSON,
    WebApiModelsEnumerationTypesEventTypeFromJSONTyped,
    WebApiModelsEnumerationTypesEventTypeToJSON,
} from './WebApiModelsEnumerationTypesEventType';
import type { WebApiModelsEnumerationTypesTimeChoice } from './WebApiModelsEnumerationTypesTimeChoice';
import {
    WebApiModelsEnumerationTypesTimeChoiceFromJSON,
    WebApiModelsEnumerationTypesTimeChoiceFromJSONTyped,
    WebApiModelsEnumerationTypesTimeChoiceToJSON,
} from './WebApiModelsEnumerationTypesTimeChoice';

/**
 * Data transfer object for the M:WebApi.Services.Interfaces.IUserService.RegisterAsync(WebApi.Services.DataTransferObjects.UserService.RegisterReqDto,System.String) request.
 * @export
 * @interface WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
 */
export interface WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    name?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    deadline?: Date;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesDisplayType}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    displayType?: WebApiModelsEnumerationTypesDisplayType;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    location?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    allowWaitlist?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    maxWaitlist?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    membersOnly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    showOnMemberSite?: boolean;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesEventType}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    eventType?: WebApiModelsEnumerationTypesEventType;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesTimeChoice}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    timeChoice?: WebApiModelsEnumerationTypesTimeChoice;
    /**
     * 
     * @type {boolean}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    sendAutomaticReminder?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    automaticReminderDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto
     */
    maxParticipants?: number | null;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDtoFromJSON(json: any): WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto {
    return WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'deadline': !exists(json, 'deadline') ? undefined : (new Date(json['deadline'])),
        'displayType': !exists(json, 'displayType') ? undefined : WebApiModelsEnumerationTypesDisplayTypeFromJSON(json['displayType']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'allowWaitlist': !exists(json, 'allowWaitlist') ? undefined : json['allowWaitlist'],
        'maxWaitlist': !exists(json, 'maxWaitlist') ? undefined : json['maxWaitlist'],
        'membersOnly': !exists(json, 'membersOnly') ? undefined : json['membersOnly'],
        'showOnMemberSite': !exists(json, 'showOnMemberSite') ? undefined : json['showOnMemberSite'],
        'eventType': !exists(json, 'eventType') ? undefined : WebApiModelsEnumerationTypesEventTypeFromJSON(json['eventType']),
        'timeChoice': !exists(json, 'timeChoice') ? undefined : WebApiModelsEnumerationTypesTimeChoiceFromJSON(json['timeChoice']),
        'sendAutomaticReminder': !exists(json, 'sendAutomaticReminder') ? undefined : json['sendAutomaticReminder'],
        'automaticReminderDays': !exists(json, 'automaticReminderDays') ? undefined : json['automaticReminderDays'],
        'maxParticipants': !exists(json, 'maxParticipants') ? undefined : json['maxParticipants'],
    };
}

export function WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDtoToJSON(value?: WebApiServicesDataTransferObjectsUserServiceUpdateEventWithBookingsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'deadline': value.deadline === undefined ? undefined : (value.deadline.toISOString()),
        'displayType': WebApiModelsEnumerationTypesDisplayTypeToJSON(value.displayType),
        'description': value.description,
        'location': value.location,
        'allowWaitlist': value.allowWaitlist,
        'maxWaitlist': value.maxWaitlist,
        'membersOnly': value.membersOnly,
        'showOnMemberSite': value.showOnMemberSite,
        'eventType': WebApiModelsEnumerationTypesEventTypeToJSON(value.eventType),
        'timeChoice': WebApiModelsEnumerationTypesTimeChoiceToJSON(value.timeChoice),
        'sendAutomaticReminder': value.sendAutomaticReminder,
        'automaticReminderDays': value.automaticReminderDays,
        'maxParticipants': value.maxParticipants,
    };
}

